'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { LogIn, LogOut, Zap, Menu, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function TopbarActions() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, signOut, signInWithEmail } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch {
      // silent
    }
    setMobileOpen(false);
  };

  const handleSignIn = async () => {
    try {
      await signInWithEmail('demo@sayit.com', 'demo1234');
    } catch {
      // silent
    }
    setMobileOpen(false);
  };

  return (
    <div className="flex items-center gap-3">
      {/* Desktop */}
      <div className="hidden sm:flex items-center gap-3">
        <Link
          href="/boost-payment-screen"
          className="flex items-center gap-1.5 text-sm font-semibold text-boost bg-boost-bg px-3 py-1.5 rounded-lg hover:bg-amber-100 transition-all duration-150 active:scale-95"
        >
          <Zap size={14} />
          Boost
        </Link>
        {user ? (
          <button
            onClick={handleSignOut}
            className="flex items-center gap-1.5 text-sm font-semibold text-muted-foreground border border-border px-3 py-1.5 rounded-lg hover:bg-muted transition-all duration-150 active:scale-95"
          >
            <LogOut size={14} />
            Sign Out
          </button>
        ) : (
          <button
            onClick={handleSignIn}
            className="flex items-center gap-1.5 text-sm font-semibold text-primary-foreground bg-primary px-3 py-1.5 rounded-lg hover:bg-indigo-600 transition-all duration-150 active:scale-95"
          >
            <LogIn size={14} />
            Sign In
          </button>
        )}
      </div>

      {/* Mobile hamburger */}
      <button
        className="sm:hidden p-2 rounded-lg hover:bg-muted transition-colors"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle menu"
      >
        {mobileOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="absolute top-14 left-0 right-0 bg-card border-b border-border p-4 flex flex-col gap-3 sm:hidden shadow-lg z-50">
          <Link
            href="/boost-payment-screen"
            className="flex items-center gap-2 text-sm font-semibold text-boost bg-boost-bg px-4 py-2.5 rounded-lg hover:bg-amber-100 transition-all duration-150"
            onClick={() => setMobileOpen(false)}
          >
            <Zap size={16} />
            Boost a Post
          </Link>
          {user ? (
            <button
              onClick={handleSignOut}
              className="flex items-center gap-2 text-sm font-semibold text-muted-foreground border border-border px-4 py-2.5 rounded-lg hover:bg-muted transition-all duration-150"
            >
              <LogOut size={16} />
              Sign Out
            </button>
          ) : (
            <button
              onClick={handleSignIn}
              className="flex items-center gap-2 text-sm font-semibold text-primary-foreground bg-primary px-4 py-2.5 rounded-lg hover:bg-indigo-600 transition-all duration-150"
            >
              <LogIn size={16} />
              Sign In with Google
            </button>
          )}
        </div>
      )}
    </div>
  );
}